import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { videoFetcher } from "../api/requests";

const VideosContext = createContext();

const VideosContextProvider = ({ children }) => {
  const [videos, setVideos] = useState({});

  const updateVideos = useCallback((newData) => {
    setVideos(newData);
  }, []);

  useEffect(() => {
    const getVideos = async () => {
      try {
        setVideos(await videoFetcher.getConfirmedVideos(""));
      } catch (err) {
        console.error(err);
      }
    };
    getVideos();
  }, []);

  const contextValue = useMemo(
    () => ({
      videos,
      updateVideos,
    }),
    [videos, updateVideos]
  );

  return (
    <VideosContext.Provider value={contextValue}>
      {children}
    </VideosContext.Provider>
  );
};

export { VideosContext, VideosContextProvider };
